import React from 'react';
import moment from 'moment';
import { Dropdown, Form, Item, Input, Grid } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';

import withCountriesOptions from '../../../HOC/withCountriesOptions';
import AirlineDropdown from '../../../dropdowns/AirlineDropdown';
import FlightNumberDropdown from '../../../dropdowns/FlightNumberDropdown';
import PassengerEmailDropdown from '../../../dropdowns/PassengerEmailDropdown';
import SelectedFiltersLabels from '../../../SelectedFiltersLabels';
import { disturbanceOptions } from '../../../../options/disturbanceOptions';

const ClaimSearchForm = ({
  values,
  onSubmit,
  onMultipleFilterAdd,
  onSingleFilterAdd,
  onReject,
  selectedFiltersLabels,
  countriesOptions,
  onDateFilterChange,
  onFilterDelete
}) => (
  <Form onSubmit={onSubmit}>
    <Grid>
      <Grid.Row columns="equal">
        <Grid.Column>
          <SelectedFiltersLabels
            filter="airlineNames"
            filters={values}
            onFilterDelete={onFilterDelete}
          />
        </Grid.Column>
        <Grid.Column>
          <SelectedFiltersLabels
            filter="flightNumbers"
            filters={values}
            onFilterDelete={onFilterDelete}
          />
        </Grid.Column>
        <Grid.Column>
          <SelectedFiltersLabels
            filter="countryNames"
            filters={values}
            onFilterDelete={onFilterDelete}
          />
        </Grid.Column>
        <Grid.Column>
          <SelectedFiltersLabels
            filter="reasons"
            filters={values}
            onFilterDelete={onFilterDelete}
          />
        </Grid.Column>
        <Grid.Column>
          <SelectedFiltersLabels
            filter="passengerEmails"
            filters={values}
            onFilterDelete={onFilterDelete}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
    <Form.Group widths="equal">
      <Form.Field>
        <AirlineDropdown
          labelled
          placeholder
          value={[]}
          optionsValue="name"
          multiple
          onChange={onMultipleFilterAdd.bind(this, 'airlineNames')}
        />
      </Form.Field>
      <Form.Field>
        <FlightNumberDropdown
          label="Flight Number"
          multiple
          value={[]}
          onChange={onMultipleFilterAdd.bind(this, 'flightNumbers')}
        />
      </Form.Field>
      <Form.Field>
        <label>Country</label>
        <Dropdown
          fluid
          multiple
          search
          selection
          options={countriesOptions}
          value={[]}
          onChange={onMultipleFilterAdd.bind(this, 'countryNames')}
        />
      </Form.Field>
      <Form.Field>
        <label>Type of Disturbance</label>
        <Dropdown
          fluid
          multiple
          search
          selection
          options={disturbanceOptions}
          onChange={onMultipleFilterAdd.bind(this, 'reasons')}
          value={[]}
        />
      </Form.Field>
      <Form.Field>
        <label>Passenger Email</label>
        <PassengerEmailDropdown
          value={[]}
          multiple
          onChange={onMultipleFilterAdd.bind(this, 'passengerEmails')}
        />
      </Form.Field>
    </Form.Group>
    <Form.Group widths="equal">
      <Form.Field>
        <label>PAX name</label>
        <Form.Input
          fluid
          value={values.passengerFullNames[0] || ''}
          onChange={onSingleFilterAdd.bind(this, 'passengerFullNames')}
        />
      </Form.Field>
      <Form.Field>
        <label>Claim number</label>
        <Form.Input
          fluid
          value={values.claimCodes[0] || ''}
          onChange={onSingleFilterAdd.bind(this, 'claimCodes')}
        />
      </Form.Field>
      <Form.Field>
        <label>Flight date</label>
        <Item className="c-DatePicker__wrapper c-DatePicker__wrapper--filters">
          <DatePicker
            selected={values.flightDate && moment(values.flightDate)}
            onChange={onDateFilterChange}
            isClearable
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            customInput={<Input style={{ width: '100%' }} />}
          />
        </Item>
      </Form.Field>
    </Form.Group>
    <Form.Group>
      <Form.Button floated="right" primary style={{ marginBottom: '15px' }}>
        Search
      </Form.Button>
      <Form.Button
        type="button"
        floated="right"
        primary
        style={{ marginBottom: '15px' }}
        onClick={onReject}
      >
        Reject
      </Form.Button>
    </Form.Group>
  </Form>
);

export default withCountriesOptions(ClaimSearchForm);



// WEBPACK FOOTER //
// ./src/component/tasks/AssignMessageTask/ClaimSearch/Form.js